import React from 'react';
import { Link } from 'gatsby';

import { Container } from './styles';
import Wrapper from '../../ui/Wrappers';
import { externalLink } from "../../ui/helpers";

interface IProps {
  className?: string;
  data?: any;
}

const WebMap = ({ data }: IProps) => {
  return (
    <Wrapper
      as={Container}
      size="mainwrapper"
      data-gtm-action="footer"
      data-gtm-category="navegacion">
      {data &&
        data.map((value, i) => (
          <div key={value.title + '_' + i} className="column">
            <div className="label">{value.title}</div>
            {value.childrenMenuItems && (
              <ul>
                {value.childrenMenuItems.map((item, j) => {
                  if (!item.title.includes("Informes EINF")) {
                    return (
                      <li key={item.value + '_' + j}>

                        {externalLink(item.url) ?
                          <a
                            href={item.url}
                            target={'_blank'}
                            data-gtm-event data-gtm-label={item.url}
                          >
                            {item.title}
                          </a>
                          :
                          <Link to={item.url || '#'} data-gtm-event data-gtm-label={item.url}>
                            {item.title}
                          </Link>
                        }
                      </li>
                    )
                  } else {
                    const yearLinks = [
                      { year: "2021", url: "https://5313163.fs1.hubspotusercontent-na1.net/hubfs/5313163/EINFF 2021.pdf " },
                      { year: "2022", url: "https://5313163.fs1.hubspotusercontent-na1.net/hubfs/5313163/EINF 2022.pdf " },
                      { year: "2023", url: "https://5313163.fs1.hubspotusercontent-na1.net/hubfs/5313163/EINFF 2023.pdf " },
                      { year: "2024", url: "https://5313163.fs1.hubspotusercontent-na1.net/hubfs/5313163/EINFF%202024.pdf" }
                    ];

                    return (
                      <li key={item.value + '_' + j} style={{ color: 'white' }}>
                        <span>Informes EINF: </span>

                        {yearLinks.map((link, index) => (
                          <React.Fragment key={link.year}>
                            <a
                              href={link.url}
                              target={'_blank'}
                              data-gtm-event
                              data-gtm-label={link.url}
                              style={{ color: 'white' }}
                            >
                              {link.year}
                            </a>
                            {index < yearLinks.length - 1 && " / "}
                          </React.Fragment>
                        ))}
                      </li>
                    );
                  }
                })}
              </ul>
            )}
          </div>
        ))}
    </Wrapper>
  );
};

export default WebMap;
